import { ONBOARDING_PATHS } from './paths';

export type OnboardingPageId = 'index' | 'verification' | 'get-started';

export type OnboardingRedirectInput = {
  page: OnboardingPageId;
  isVerified: boolean;
  isEligible: boolean;
  isComplete: boolean;
  hasAnswered: boolean;
};

/**
 * Where an `/onboarding/*` page should send the user, or `null` to stay.
 * Pure so the whole gate matrix is unit-tested once; pages render a
 * `SafeNavigate` off the answer.
 *
 * - Ineligible accounts and accounts that already finished onboarding in any
 *   workspace skip the flow entirely and land on home (`/` forwards there).
 * - Unverified users can only sit on the verification gate.
 * - Verified users who already answered the get-started question are done
 *   with `/onboarding` — home's checklist is their next step.
 * - Verified users have no business on the verification gate — they move on
 *   to the get-started question.
 */
export function selectOnboardingRedirect(input: OnboardingRedirectInput): string | null {
  const { page, isVerified, isEligible, isComplete, hasAnswered } = input;

  if (!isEligible || isComplete) {
    return '/';
  }
  if (!isVerified) {
    return page === 'verification' ? null : ONBOARDING_PATHS.verification;
  }
  if (hasAnswered) {
    return '/';
  }
  return page === 'get-started' ? null : ONBOARDING_PATHS.getStarted;
}
